var map = {
	"./Marketing/delete-gray.svg": "13ee",
	"./Marketing/delete.svg": "142f",
	"./Marketing/download.svg": "f4c8",
	"./Marketing/edit.svg": "3b90",
	"./Marketing/options.svg": "c4e5",
	"./Marketing/save.svg": "a797",
	"./Marketing/share-blue.svg": "1816",
	"./Marketing/share.svg": "5170",
	"./Party.svg": "1f47",
	"./Vector.png": "5cd0",
	"./ZoomSlider/minus.svg": "280e",
	"./ZoomSlider/plus.svg": "3e4c",
	"./activation-email-flow.png": "8454",
	"./app-store.png": "8998",
	"./app/app-close-button.png": "b91f",
	"./app/app-share-button.png": "53ac",
	"./app/app-status-bar-status.png": "6682d",
	"./arrow-down.svg": "2e6ed",
	"./arrow-upload.svg": "8798",
	"./award-coins.svg": "6ffd",
	"./back-arrow-left-v2.svg": "c122",
	"./back-arrow-left.svg": "62db",
	"./background.svg": "ac03",
	"./birthday-tag.svg": "0706",
	"./brand-coin.svg": "1294",
	"./business-coin-placeholder.svg": "9056",
	"./business-onboarding/ai-signup/coin-placeholder.png": "4dca",
	"./business-onboarding/ai-signup/coin-shadow.png": "e3da4",
	"./business-onboarding/ai-signup/gift-cover-medium.png": "d2df",
	"./business-onboarding/ai-signup/gift-cover.png": "88bb",
	"./business-onboarding/business-preview/pin.png": "8b54",
	"./business-onboarding/business-preview/smile-face.png": "c0ce",
	"./business-onboarding/business-preview/sparkles.png": "1a69",
	"./business-onboarding/business-preview/telephone.png": "00d6",
	"./business-onboarding/business-preview/waving.png": "da7d",
	"./business-onboarding/business-preview/website.png": "2614",
	"./business-onboarding/category/arts.png": "b28a",
	"./business-onboarding/category/beauty.png": "6184",
	"./business-onboarding/category/education.png": "f158",
	"./business-onboarding/category/food.png": "b8ba",
	"./business-onboarding/category/health.png": "9d25",
	"./business-onboarding/category/other.png": "855e",
	"./business-onboarding/category/pets.png": "d513",
	"./business-onboarding/category/shopping.png": "20a5",
	"./business-onboarding/category/sports.png": "ce35",
	"./business-onboarding/confetti.png": "91b9",
	"./business-onboarding/lines-background.png": "a70e",
	"./business-onboarding/welcome-twism/background-connections-mobile.png": "591b",
	"./business-onboarding/welcome-twism/background-connections.png": "ed97",
	"./business-onboarding/welcome-twism/background.png": "d2b1",
	"./business-onboarding/welcome-twism/connections-circles.png": "e3da",
	"./business-onboarding/welcome-twism/connections-mobile-circles.png": "a9af",
	"./business-onboarding/welcome-twism/connections-woman.png": "ee6b3",
	"./business-onboarding/welcome-twism/mobile-circles.png": "990e",
	"./business-onboarding/welcome-twism/welcome-big-screen-circles.png": "2349",
	"./business-onboarding/welcome-twism/welcome-circles.png": "dfe5",
	"./calendar-check.svg": "7176",
	"./card-brands/amex.png": "a653",
	"./card-brands/mastercard.png": "eb0a",
	"./card-brands/visa.png": "c444",
	"./cart.svg": "d176",
	"./checked.svg": "94f7",
	"./checkmark.svg": "83e5",
	"./close-blue.svg": "eb2e",
	"./close-dark.svg": "91fe",
	"./close-square.svg": "0e86",
	"./close.svg": "1d1b",
	"./coin-equals-to.svg": "80d3",
	"./coin-network/join-coin-network-image.png": "1e92",
	"./coin-network/news-for-you-image.png": "db2b",
	"./confirmation-ilustra.svg": "f0be",
	"./copy.svg": "87d1",
	"./danger.svg": "e7c1",
	"./drag-and-drop.svg": "f7f7",
	"./drag.svg": "e581",
	"./email-preview.png": "c860",
	"./empty-state-background.svg": "7cbf",
	"./gift-2.svg": "4104",
	"./gift-icon.svg": "26d4",
	"./gift.svg": "2e5e",
	"./giftCoinCards/empty-state-card.svg": "fe3b",
	"./giftCoinCards/stripe-logo.svg": "152c",
	"./google-play.png": "fec7",
	"./green-arrow.svg": "31116",
	"./home-cards/branded-coin.png": "1ac7",
	"./home-cards/coin-network.png": "bfdc",
	"./home-cards/email-automation.png": "d388",
	"./home-cards/help-center.png": "5898",
	"./home-cards/invite-customer.png": "2118",
	"./home-cards/loyalty-program.png": "4184",
	"./home-cards/metrics.png": "ccaf",
	"./home-cards/mobile/branded-coin.png": "72f9",
	"./home-cards/mobile/coin-network.png": "6d53",
	"./home-cards/mobile/email-automation.png": "3c72",
	"./home-cards/mobile/help-center.png": "2521",
	"./home-cards/mobile/invite-customer.png": "9202",
	"./home-cards/mobile/loyalty-program.png": "b1d5",
	"./home-cards/mobile/metrics.png": "6878",
	"./home-cards/mobile/offer.png": "a55f",
	"./home-cards/mobile/referral.png": "a7ee",
	"./home-cards/mobile/sell-coins.png": "f89b",
	"./home-cards/mobile/social-rewards.png": "4741",
	"./home-cards/mobile/welcome-coins.png": "603d",
	"./home-cards/mobile/widget.png": "4c0a",
	"./home-cards/offer.png": "f31a",
	"./home-cards/referral.png": "eb9a",
	"./home-cards/sell-coins.png": "fcee",
	"./home-cards/social-rewards.png": "4272",
	"./home-cards/welcome-coins.png": "0ed3",
	"./home-cards/widget.png": "68a9",
	"./home-customer-list-avatar/1.png": "e14b",
	"./home-customer-list-avatar/2.png": "b9ec",
	"./home-customer-list-avatar/3.png": "c31a",
	"./home-customer-list-avatar/4.png": "fbbfb",
	"./home-customer-list-empty-state.svg": "6ff2",
	"./icons/activity.svg": "4b34",
	"./icons/alert.svg": "8546",
	"./icons/arrow-2-blue.svg": "aae31",
	"./icons/arrow-2.svg": "83ad",
	"./icons/arrow-down.svg": "5c3c",
	"./icons/arrow-up.svg": "52007",
	"./icons/arrow-with-circle.svg": "bbf4",
	"./icons/background-twism-gradient.svg": "03c4",
	"./icons/background-twism.svg": "8889",
	"./icons/bank-bg.svg": "b4c6",
	"./icons/bank.svg": "a10a",
	"./icons/check.svg": "5236",
	"./icons/clock-blue.svg": "6366",
	"./icons/coins.svg": "2cc5",
	"./icons/currency.svg": "02cd",
	"./icons/dashboard.svg": "5451",
	"./icons/dollar-symbol.svg": "9548",
	"./icons/edit.svg": "8399",
	"./icons/error.svg": "2804",
	"./icons/filter.svg": "8e90",
	"./icons/gift-coin.svg": "1055",
	"./icons/gift.svg": "bcab",
	"./icons/globe.svg": "22b8",
	"./icons/horn.svg": "123b",
	"./icons/lock-blue.svg": "e995",
	"./icons/logout.svg": "24fc",
	"./icons/map-pin.svg": "c7b2",
	"./icons/navigation.svg": "16eb",
	"./icons/offers.svg": "2a18",
	"./icons/pencil-blue.svg": "2402",
	"./icons/percent.svg": "7db8",
	"./icons/phone.svg": "9855",
	"./icons/pin-plus.svg": "95a2",
	"./icons/pin.svg": "958c",
	"./icons/plus-blue.svg": "ae04",
	"./icons/plus.svg": "8c7a",
	"./icons/search.svg": "0930",
	"./icons/settings.svg": "cbdc",
	"./icons/share-app.svg": "9dd5",
	"./icons/shopping.svg": "d632",
	"./icons/success.svg": "17bf",
	"./icons/transfer.svg": "7b18",
	"./icons/twism-dark.svg": "e4b9",
	"./icons/twism-full-logo-light.svg": "e5f1",
	"./icons/twism-full-logo.svg": "c47b",
	"./icons/twism-light.svg": "282c",
	"./icons/twism-logo-white.svg": "031f",
	"./icons/twism-new-logo.svg": "6522",
	"./icons/twism.svg": "1d0a",
	"./icons/user.svg": "7393",
	"./icons/users.svg": "3a68",
	"./icons/warning.svg": "248b",
	"./icons/withdrawal-failed.svg": "40c2",
	"./icons/withdrawal-processing.svg": "9975",
	"./icons/withdrawal-success.svg": "9f59",
	"./image-empty.svg": "f9e4",
	"./image-placeholder.png": "d905",
	"./info.svg": "50c1",
	"./instore-online/operation-both-success.png": "f05b",
	"./instore-online/operation-both.png": "d07f",
	"./internationalization/flags/Canada.png": "2718",
	"./internationalization/flags/United Kingdom.png": "173f",
	"./internationalization/flags/United States.png": "a258",
	"./invite-customer-in-store/invite-customer-steps.png": "1328",
	"./iphone-x-status-bar.png": "4d06",
	"./list-icon.png": "3f4e",
	"./logo-light.svg": "cf26",
	"./logo-white.svg": "e1d6",
	"./logo.svg": "1ae4",
	"./loyalty-background.png": "53b2",
	"./loyalty-reward-item-free.svg": "2df0",
	"./loyalty-reward-item.svg": "fe21",
	"./loyalty-title.svg": "d3c9",
	"./manage-locations/empty-state.png": "3b88",
	"./marketingCenter/birthday-template.png": "2d14",
	"./marketingCenter/canvas/birthday/facebook-post.png": "48b8",
	"./marketingCenter/canvas/birthday/instagram-post.png": "b53da",
	"./marketingCenter/canvas/birthday/instagram-story.png": "b8ed",
	"./marketingCenter/canvas/footer.svg": "739e",
	"./marketingCenter/canvas/gift/facebook-post.png": "8059",
	"./marketingCenter/canvas/gift/instagram-post.png": "097d9",
	"./marketingCenter/canvas/gift/instagram-story.png": "57d5",
	"./marketingCenter/canvas/hello/orange.svg": "83df",
	"./marketingCenter/canvas/logo.svg": "2365",
	"./marketingCenter/canvas/loyalty/button.svg": "39ba",
	"./marketingCenter/canvas/loyalty/facebook-post.png": "48e6",
	"./marketingCenter/canvas/loyalty/instagram-post.png": "0e88",
	"./marketingCenter/canvas/loyalty/instagram-story.png": "6d5c",
	"./marketingCenter/canvas/notification-coins.png": "018c",
	"./marketingCenter/canvas/offer/facebook-post.png": "cb2a",
	"./marketingCenter/canvas/offer/instagram-post.png": "b59c",
	"./marketingCenter/canvas/offer/instagram-story.png": "c3f3",
	"./marketingCenter/custom-template.png": "f516",
	"./marketingCenter/empty-background.svg": "cb38",
	"./marketingCenter/empty-header.png": "5418",
	"./marketingCenter/formats/facebook-post.svg": "ba53",
	"./marketingCenter/formats/instagram-post.svg": "0a90",
	"./marketingCenter/formats/instagram-story.svg": "5ffe",
	"./marketingCenter/gift-template.png": "ab91",
	"./marketingCenter/hello-template.png": "9958",
	"./marketingCenter/loyalty-template.png": "3e6e",
	"./marketingCenter/offer-template.png": "1a95",
	"./marketingCenter/socials/facebook.svg": "756d",
	"./marketingCenter/socials/instagram.svg": "6edf",
	"./members/birthday-icon.png": "5c7d",
	"./members/favorited-icon.png": "9b03",
	"./merchantConnect/Subtract.png": "2dbb",
	"./merchantConnect/providerConnectImage.png": "f4ec",
	"./merchantConnect/providerConnectWidget.png": "a4c8",
	"./merchantConnect/providers-bg.jpg": "b0ef",
	"./merchantConnect/providers-ellipsis.png": "befd",
	"./merchantID-top.svg": "a629",
	"./new-logo.svg": "0bc7",
	"./notification_empty.svg": "9d05",
	"./offerFreeCoins/app-empty-state.png": "d898",
	"./offerFreeCoins/app-mockup-v2.png": "6236",
	"./offerFreeCoins/app-mockup.png": "7679",
	"./offerFreeCoins/coins-instructions-illustration.svg": "cc0a",
	"./offerFreeCoins/coins.svg": "8094",
	"./offerFreeCoins/customer-perspective.png": "693c",
	"./offerFreeCoins/share-blue.svg": "fdcc",
	"./offerFreeCoins/tab-background-left-v2.svg": "3d7d",
	"./offerFreeCoins/tab-background-left.svg": "3c2b",
	"./offerFreeCoins/tab-background-right-v2.svg": "da832",
	"./offerFreeCoins/tab-background-right.svg": "fbff",
	"./offerFreeCoins/widget-coupon-mockup.svg": "c161",
	"./offerFreeCoins/widget-empty-state.png": "ab11",
	"./offerFreeCoins/widget-mockup-v2.png": "427d",
	"./offerFreeCoins/widget-mockup.png": "c3b4",
	"./offers/baloonn.svg": "0dcd",
	"./offers/cake.svg": "8574",
	"./offers/confetti.svg": "786b",
	"./offers/coupon.svg": "033f",
	"./offers/ellipse.svg": "c6a8",
	"./offers/empty-birthday-offer-1.png": "a344",
	"./offers/empty-birthday-offer-2.png": "9788",
	"./offers/empty-offer-1.png": "6775",
	"./offers/empty-offer-2.png": "4d4c",
	"./offers/empty-state-background.svg": "09b8",
	"./offers/empty-state-store-1.png": "3419",
	"./offers/empty-state-store-2.png": "51de",
	"./offers/general.svg": "acff",
	"./offers/specific.svg": "9da1",
	"./onboardingCall/banner/left-done.png": "70a3",
	"./onboardingCall/banner/left-scheduled.png": "08fc",
	"./onboardingCall/banner/left-to-be-scheduled.png": "e68e",
	"./onboardingCall/banner/mobile-done.png": "66f1",
	"./onboardingCall/banner/mobile-scheduled.png": "f63e",
	"./onboardingCall/banner/mobile-to-be-scheduled.png": "fbe3",
	"./onboardingCall/banner/right-done.png": "0cc2",
	"./onboardingCall/banner/right-scheduled.png": "40e1",
	"./onboardingCall/banner/right-to-be-scheduled.png": "60e3",
	"./onboardingCall/modal-image-mobile.png": "401a",
	"./onboardingCall/modal-image.png": "41a0",
	"./party-popper.svg": "3436",
	"./performance/card-transactions.svg": "08ef",
	"./performance/customers.svg": "d5b2",
	"./performance/purchased-coins.svg": "47fa",
	"./performance/rewarded-coins.svg": "cb9d",
	"./play-circle.svg": "f424",
	"./play.svg": "cc2e",
	"./plus.svg": "2beb",
	"./powered-by-twism.svg": "13dd",
	"./question.svg": "5009",
	"./referral/background.png": "6a4c",
	"./registration/birthday-club.svg": "98db",
	"./registration/coffee.svg": "d18e",
	"./registration/coins-timer.svg": "f8cf",
	"./registration/coins.svg": "30ab",
	"./registration/dolar.svg": "57d1",
	"./registration/dollar-coin.svg": "475b",
	"./registration/dollar-currency.svg": "a447",
	"./registration/free-coins.svg": "66ec",
	"./registration/gift-box.svg": "b66c",
	"./registration/gift-coin.svg": "1f10",
	"./registration/integrations.svg": "a8d0",
	"./registration/manage.svg": "0f28",
	"./registration/megaphone.svg": "44f9",
	"./registration/offers.svg": "74a7",
	"./registration/pending.svg": "8119",
	"./registration/percentage.svg": "07ac",
	"./registration/registration-progress.svg": "8a44",
	"./registration/seen.svg": "8a21",
	"./registration/social-media.svg": "7f3e",
	"./registration/sound-table-icon.svg": "5b74",
	"./registration/text.svg": "8467",
	"./reward-modal/feedback-status-ilustra.png": "c2c1",
	"./reward-modal/introduction-ilustra.png": "1c96",
	"./reward-modal/introduction-platform-ilustra.png": "a610",
	"./reward-modal/introduction-pos-system-ilustra.png": "a81d",
	"./reward-modal/refund-policy-ilustra.png": "f17e",
	"./reward-modal/reward-ratio-ilustra.png": "3750",
	"./reward-onboarding/circle-arrow-right.png": "a229",
	"./reward-onboarding/refund-policy-ilustra.png": "d144",
	"./reward-onboarding/reward-ratio-ilustra.png": "7b3a",
	"./reward-onboarding/select-reward-ilustra.png": "0584",
	"./sellCoins/activate-header-background.png": "a90e",
	"./sellCoins/avatar-group.png": "7acd",
	"./sellCoins/banner-mobile.png": "85d1",
	"./sellCoins/banner.png": "3605",
	"./sellCoins/campaign/app-preview-card.png": "1f2c",
	"./sellCoins/campaign/app-preview-v2.png": "0590",
	"./sellCoins/campaign/app-preview.png": "9cae",
	"./sellCoins/empty-state.png": "631f",
	"./send-offers.svg": "5058",
	"./share.svg": "8096",
	"./shine.svg": "4b890",
	"./shopify-extension-banner/icons-bg.png": "970f",
	"./shopify-extension-banner/texture-bg.png": "3f6d",
	"./signin/success.svg": "1641",
	"./signup-coins-2.png": "159e",
	"./signup-coins.png": "5f1f",
	"./signup-ellipse-filled.png": "1621",
	"./signup-ellipse.png": "0ffa",
	"./signup-empty.svg": "fea6",
	"./signup-logo-light.svg": "084f",
	"./signup/mail.svg": "a04c",
	"./signup/phone.svg": "f65c",
	"./signup/pin.svg": "0ce2",
	"./signup/user.svg": "b676",
	"./small-close.svg": "9ba7",
	"./socialRewards/widget-social-rewards.svg": "11a5",
	"./socials/facebook.svg": "db0e",
	"./socials/instagram.svg": "c7fd",
	"./socials/linkedin.svg": "ae86",
	"./socials/twitter.svg": "52c7",
	"./specialCoinOffer/empty-state.png": "da5e",
	"./specialCoinOffer/new-empty-state.png": "b01d",
	"./spinning-coin-front.png": "4bc7",
	"./square_ilustra.png": "dbf5",
	"./steps.svg": "38d35",
	"./stripe-logo.svg": "9db5",
	"./stripe.png": "8d08",
	"./stripe.svg": "2576",
	"./tour/customer-thumbs.png": "1d8d",
	"./tour/user-1.png": "59af",
	"./tour/user-2.png": "ccec",
	"./trash.svg": "5665",
	"./twism.png": "7f72",
	"./twismPattern.svg": "8fc2",
	"./user.svg": "f41a",
	"./warning.svg": "449c",
	"./welcome-box.svg": "122c",
	"./widget/bg-coin.svg": "523b",
	"./widget/confetis.svg": "cc2e0",
	"./widget/empty-state-widget.svg": "f8d2",
	"./widget/shopify.png": "2f0a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";